/* eslint-disable arrow-body-style */
import {
  CREATE_CALL_CENTER_AGENT_FAILURE,
  CREATE_CALL_CENTER_AGENT_REQUEST,
  CREATE_CALL_CENTER_AGENT_SUCCESS,
  CREATE_POP_UP_FAILURE,
  CREATE_POP_UP_REQUEST,
  CREATE_POP_UP_SUCCESS,
  DELETE_CALL_CENTER_AGENT_FAILURE,
  DELETE_CALL_CENTER_AGENT_REQUEST,
  DELETE_CALL_CENTER_AGENT_SUCCESS,
  DELETE_POP_UP_FAILURE,
  DELETE_POP_UP_PHOTO_FAILURE,
  DELETE_POP_UP_PHOTO_REQUEST,
  DELETE_POP_UP_PHOTO_SUCCESS,
  DELETE_POP_UP_REQUEST,
  DELETE_POP_UP_SUCCESS,
  GET_CALL_CENTER_AGENTS_FAILURE,
  GET_CALL_CENTER_AGENTS_LOG_FAILURE,
  GET_CALL_CENTER_AGENTS_LOG_REQUEST,
  GET_CALL_CENTER_AGENTS_LOG_SUCCESS,
  GET_CALL_CENTER_AGENTS_REQUEST,
  GET_CALL_CENTER_AGENTS_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_POP_UPS_FAILURE,
  GET_POP_UPS_REQUEST,
  GET_POP_UPS_SUCCESS,
  GET_REMOTE_DOORMAN_CALLS_FAILURE,
  GET_REMOTE_DOORMAN_CALLS_REQUEST,
  GET_REMOTE_DOORMAN_CALLS_SUCCESS,
  GET_REMOTE_DOORMAN_CALL_FAILURE,
  GET_REMOTE_DOORMAN_CALL_REQUEST,
  GET_REMOTE_DOORMAN_CALL_SUCCESS,
  GET_SERVICE_USERS_FAILURE,
  GET_SERVICE_USERS_REQUEST,
  GET_SERVICE_USERS_SUCCESS,
  UPDATE_POP_UP_FAILURE,
  UPDATE_POP_UP_REQUEST,
  UPDATE_POP_UP_SUCCESS,
  UPDATE_RD_DOORS_FAILURE,
  UPDATE_RD_DOORS_REQUEST,
  UPDATE_RD_DOORS_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';

export const getRemoteDoormanCalls = (dispatch, queryParams, isExport) => {
  return dispatch({
    type: GET_REMOTE_DOORMAN_CALLS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.remoteDoorman.getCalls(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_REMOTE_DOORMAN_CALLS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: GET_REMOTE_DOORMAN_CALLS_FAILURE,
          err,
        });
      },
    ),
  });
};

export const getRemoteDoormanCallById = (dispatch, callId) => {
  return dispatch({
    type: GET_REMOTE_DOORMAN_CALL_REQUEST,
    payload: apiClient.remoteDoorman.getCallById(callId).then(
      (res) => {
        dispatch({
          type: GET_REMOTE_DOORMAN_CALL_SUCCESS,
          res,
        });
        return res?.data;
      },
      (err) => {
        return dispatch({
          type: GET_REMOTE_DOORMAN_CALL_FAILURE,
          err,
        });
      },
    ),
  });
};

export const getServiceUsers = (dispatch) => {
  const queryParams = { is_service: true, disable_pagination: true };
  return dispatch({
    type: GET_SERVICE_USERS_REQUEST,
    payload: apiClient.admin.allPersons(queryParams).then(
      (res) => {
        dispatch({
          type: GET_SERVICE_USERS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: GET_SERVICE_USERS_FAILURE,
          err,
        });
      },
    ),
  });
};

export const getCallCenterAgentsList = (dispatch, queryParams, isExport) => {
  return dispatch({
    type: GET_CALL_CENTER_AGENTS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.callCenter.agentsList(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_CALL_CENTER_AGENTS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: GET_CALL_CENTER_AGENTS_FAILURE,
          err,
        });
      },
    ),
  });
};

export const getCallCenterAgentsLog = (dispatch, queryParams, isExport) => {
  return dispatch({
    type: GET_CALL_CENTER_AGENTS_LOG_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.callCenter.agentsLog(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_CALL_CENTER_AGENTS_LOG_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: GET_CALL_CENTER_AGENTS_LOG_FAILURE,
          err,
        });
      },
    ),
  });
};

export const createCallCenterAgent = (dispatch, data) => {
  return dispatch({
    type: CREATE_CALL_CENTER_AGENT_REQUEST,
    payload: apiClient.callCenter.createCCAgent(data).then(
      (res) => {
        dispatch({
          type: CREATE_CALL_CENTER_AGENT_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: CREATE_CALL_CENTER_AGENT_FAILURE,
          err,
        });
      },
    ),
  });
};

export const deleteCallCenterAgent = (dispatch, agentId) => {
  return dispatch({
    type: DELETE_CALL_CENTER_AGENT_REQUEST,
    payload: apiClient.callCenter.deleteCCAgent(agentId).then(
      (res) => {
        dispatch({
          type: DELETE_CALL_CENTER_AGENT_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: DELETE_CALL_CENTER_AGENT_FAILURE,
          err,
        });
      },
    ),
  });
};

export const getPopUpList = (dispatch, queryParams, isExport) => {
  return dispatch({
    type: GET_POP_UPS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.remoteDoorman.getPopUpList(queryParams).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_POP_UPS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: GET_POP_UPS_FAILURE,
          err,
        });
      },
    ),
  });
};

export const createPopUp = (dispatch, data) => {
  return dispatch({
    type: CREATE_POP_UP_REQUEST,
    payload: apiClient.remoteDoorman.createPopUp(data).then(
      (res) => {
        dispatch({
          type: CREATE_POP_UP_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: CREATE_POP_UP_FAILURE,
          err,
        });
      },
    ),
  });
};

export const updatePopUp = (dispatch, data) => {
  return dispatch({
    type: UPDATE_POP_UP_REQUEST,
    payload: apiClient.remoteDoorman.updatePopUp(data).then(
      (res) => {
        dispatch({
          type: UPDATE_POP_UP_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: UPDATE_POP_UP_FAILURE,
          err,
        });
      },
    ),
  });
};

export const deletePopUpPhoto = (dispatch, popUpId, photoId) => {
  return dispatch({
    type: DELETE_POP_UP_PHOTO_REQUEST,
    payload: apiClient.remoteDoorman.deletePopUpPhoto(popUpId, photoId).then(
      (res) => {
        dispatch({
          type: DELETE_POP_UP_PHOTO_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: DELETE_POP_UP_PHOTO_FAILURE,
          err,
        });
      },
    ),
  });
};

export const deletePopUp = (dispatch, popUpId) => {
  return dispatch({
    type: DELETE_POP_UP_REQUEST,
    payload: apiClient.remoteDoorman.deletePopUp(popUpId).then(
      (res) => {
        dispatch({
          type: DELETE_POP_UP_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: DELETE_POP_UP_FAILURE,
          err,
        });
      },
    ),
  });
};

export const updateRDDoors = (dispatch, buildingId, data) => {
  return dispatch({
    type: UPDATE_RD_DOORS_REQUEST,
    payload: apiClient.remoteDoorman.updateDoors(buildingId, data).then(
      (res) => {
        dispatch({
          type: UPDATE_RD_DOORS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        return dispatch({
          type: UPDATE_RD_DOORS_FAILURE,
          err,
        });
      },
    ),
  });
};
